// extracted by mini-css-extract-plugin
module.exports = {"seeLiveProject10":"Merch-module--seeLiveProject10--1Uwlh","sourceCodeProject10":"Merch-module--sourceCodeProject10--1b4t0"};